import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ApiConnectorService } from 'src/app/___LOGIC/__api/api-connector.service';
import { ResolverService } from 'src/app/___LOGIC/__common/resolver.service';
import { EditDialogComponent } from '../../__common/edit-dialog/edit-dialog.component';
import { FunctionsService } from 'src/app/___LOGIC/__common/functions.service';
import { EmailService } from 'src/app/___LOGIC/__email/email.service';


@Component({
  selector: 'app-my-profile',
  templateUrl: './my-profile.component.html',
  styleUrls: ['./my-profile.component.css']
})
export class MyProfileComponent implements OnInit {

  @Output() public packagesOut = new EventEmitter();

  profileData = {
    name: null,
    lastname: null,
    lastname2: null,
    username: null,
    address: null,
    //contact 
    email: null,
    phone1: null,
    phone2: null,
    instagram: null,

    university: null,
    goal: null,
    career: null,
    studyType: null,
    startLessons: null,
    dateFrom: null,
    dateTo: null,
    city: null,
    present: null,
    destination: null,
    //
    country: null,
    text: null,
    comments: null,
    future: null,
    uePassport: null,
    stayWorking: null,
    studySearch: null,

    atEurope: null,
    visitedCountries: null,
    apartmentBudget: null
  };

  clientDetails: any = {
    name: 'John',
    lastname: 'Doe',
    lastname2: 'Smith',
    birthday: '1990-01-01',
    age: 30,
    goal: 'Study in Europe',
    address: '123 Main St, City, Country',
    email: 'john.doe@example.com',
    phone1: '+1234567890',
    phone2: '+0987654321',
    instagram: 'https://instagram.com/johndoe',
    imageUrl: 'https://via.placeholder.com/150',
    currentStudies: 'Computer Science',
    university: 'University of Example',
    payments: 'Yes',
    apartmentFilters: '2 bedrooms, near university',
    additionalInterests: 'Traveling, Cooking',
    studyHistory: 'Bachelor in Computer Science',
    studySearch: 'Masters in Data Science',
    studyDescription: 'Looking for top universities in Europe for Data Science',
    studyType: 'Masters',
    studyConfirmation: 'Confirmed',
    hasStudentVisa: 'Yes',
    usVisa: 'No',
    uePassport: 'Yes',
    validPassport: 'Yes',
    startLessons: '2022-09-01',
    firstContactDate: '2022-01-15',
    lastContactDate: '2022-06-10',
    comments: 'Very interested in studying in Europe',
    country: 'Spain',
    atEurope: 'Yes',
    visitedCountries: 'France, Germany, Italy',
    destination: 'Barcelona',
    apartmentType: 'Shared',
    apartmentBudget: '500-700 EUR',
    apartmentBathroom: 'Private',
    stayWorking: 'Yes'
  };

  followUpData: any[] = [
    {
      status: 'In Progress',
      lastUpdatedAt: '2022-06-10',
      lastInteractionDate: '2022-06-09',
      notes: 'Reviewed application documents',
      progress: '50%',
      assignee: 'Agent A',
      serviceType: 'Study Visa',
      origin: 'Website'
    }
    // Add more follow up data as needed
  ];

  packages;
  packagesObj;
  loading = false;

  constructor(private dialog: MatDialog,private apiConnector: ApiConnectorService,private resolver: ResolverService,private commonFunctions: FunctionsService,private emailService: EmailService) { }

  ngOnInit(): void { 
    this.loading = true;
    this.apiConnector.simpleQueryId('clientPackages', this.commonFunctions.getSelectedClientId().toString(),null,null,null,null)
    .subscribe(response => this.saveDataToLocalClass2(response));
  }

  saveDataToLocalClass2(data: any){
    this.packages = data.records;
    this.processClientPackages();
  }

  processClientPackages(){
    /*     for(let item of this.packages){
          if(item.package_type === 'basic'){
            this.basic.products.push(item.product);
            this.basic.price = item.price;
            this.basic.paid = item.paid;
            this.basic.id = item.id;
            this.basic.name = item.name;
            this.basic.FK_ID_package_chosen = item.FK_ID_package_chosen;
          }
          if(item.package_type === 'premium'){
            this.premium.products.push(item.product);
            this.premium.price = item.price;
            this.premium.paid = item.paid;
            this.premium.id = item.id;
            this.premium.name = item.name;
            this.premium.FK_ID_package_chosen = item.FK_ID_package_chosen;
          }
          if(item.package_type === 'full'){
            this.full.products.push(item.product);
            this.full.price = item.price;
            this.full.paid = item.paid;
            this.full.id = item.id;
            this.full.name = item.name;
            this.full.FK_ID_package_chosen = item.FK_ID_package_chosen;
          }
        } */
    /*     this.packagesObj = [
          this.basic,
          this.premium,
          this.full
        ] */
        this.packagesOut.emit(this.packagesObj);
      }

  getSessionData(){
    return this.resolver.getDependency('userSession');
  }

  getProfileData(){
    if(this.resolver.getDependency('clientDetails') && this.resolver.getDependency('clientDetails').records){
      this.profileData = this.resolver.getDependency('clientDetails').records[0];
      return this.profileData;
    }else{
      return this.profileData;
    }
  }

  editField(field: string) {
    const dialogRef = this.dialog.open(EditDialogComponent, {
      width: '250px',
      data: { field: field, value: this.clientDetails[field] }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.clientDetails[field] = result;
      }
    });
  }

  editFollowUp(followUp: any) {
    const dialogRef = this.dialog.open(EditDialogComponent, {
      width: '250px',
      data: { field: 'followUp', value: followUp }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // Update follow up data
      }
    });
  }

  isLoading(){
    return this.resolver.isLoading('clientDetails');
  }

  getUniversityText(fullText){
    return fullText.replace(/Universidad/g, "U.");
  }

  getTotalDuration(){
    if(this.profileData.dateFrom && this.profileData.dateTo){
      return this.commonFunctions.calculateDurationInMonthsAndDays(this.profileData.dateFrom, this.profileData.dateTo);
    }else{
      // show something else
      return null;
    }
  }

  toYesNo(answer){
    let res;
    answer == 'yes'? res = 'Si': res = 'No';
    return res;
  }

  isDateEmpty(date){
    return date == "0000-00-00";
  }

  getSupportEmail(){
    return this.emailService.getAdminEmail();
  }
}
